'use client'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { debounce } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { fetchAdmins, fetchPatienten } from '../apiCalls/usersApi'
import { getAdmins } from '../Localstorage/localstorage'


const  SelectAdmins2 = ({selected, setSelected , label = true, data=[]}) =>  {
  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('');
  const {admins} = getAdmins();
  const newAdminslist = data?.length > 0 ? data : admins ;
  const [dataAdmin, setData] = useState(newAdminslist||[]);


  // Add debounced search function
  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      fetchAdmins(50, 0, searchQuery, setLoading, setError, setData);
    }, 300),
    []
  );

  return (
    <Combobox
      as="div"
      value={selected || dataAdmin[0]}
      onChange={(person) => {
        setQuery('')
        setSelected(person)
      }}
    >
      {label && <Label className="dark:text-white block text-sm/6 font-medium text-gray-900 mb-2">Zoek op specialist</Label>}
      <div className="relative">
        <ComboboxInput
          className="block w-full dark:bg-gray-800 dark:text-white rounded-md bg-white py-1.5 pl-3 pr-12 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6"
          onChange={(event) => {
            setQuery(event.target.value);
            debouncedSearch(event.target.value);
          }}
          onBlur={() => setQuery('')}
          displayValue={(person) => person?.full_name}
        />
        <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <ChevronUpDownIcon className="size-5 text-gray-400" aria-hidden="true" />
        </ComboboxButton>

        {dataAdmin.length > 0 && (
          <ComboboxOptions className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
            {data.map((person) => (
              <ComboboxOption
                key={person.id}
                value={person}
                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
              >
                <div className="flex items-center">
                  <img src={person?.avatar} alt="" className="size-6 shrink-0 rounded-full" />
                  <span className="ml-3 truncate group-data-[selected]:font-semibold">{person?.full_name}</span>
                </div>

                <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-indigo-600 group-data-[selected]:flex group-data-[focus]:text-white">
                  <CheckIcon className="size-5" aria-hidden="true" />
                </span>
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}
      </div>
    </Combobox>
  )
}

export default SelectAdmins2;